var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokLightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4045 7.91069C15.7536 7.91464 14.1431 7.39977 12.8006 6.43881V13.1408C12.8002 14.3821 12.4208 15.5937 11.7132 16.6135C11.0055 17.6333 10.0034 18.4128 8.84085 18.8478C7.67826 19.2827 6.41059 19.3523 5.20736 19.0474C4.00412 18.7424 2.92267 18.0773 2.1076 17.1411C1.29254 16.2049 0.782716 15.0422 0.646302 13.8085C0.509888 12.5747 0.753386 11.3287 1.34424 10.2371C1.93509 9.14542 2.84513 8.26017 3.95268 7.6997C5.06022 7.13923 6.31248 6.93024 7.54201 7.10069V10.4716C6.97937 10.2946 6.3752 10.2999 5.81578 10.4868C5.25636 10.6737 4.77029 11.0325 4.42699 11.5121C4.08368 11.9917 3.9007 12.5676 3.90418 13.1574C3.90765 13.7472 4.0974 14.3208 4.44633 14.7963C4.79526 15.2718 5.28552 15.6249 5.84711 15.8052C6.40869 15.9855 7.01288 15.9837 7.57339 15.8001C8.1339 15.6165 8.62207 15.2605 8.96818 14.7829C9.31429 14.3054 9.50064 13.7306 9.50063 13.1408V0.0390625H12.8006C12.7983 0.31774 12.8217 0.596038 12.8704 0.870437C12.9851 1.48299 13.2235 2.06572 13.5711 2.58296C13.9187 3.10021 14.3682 3.54111 14.892 3.87869C15.6373 4.37147 16.511 4.63412 17.4045 4.63394V7.91069Z",
    fill: "#191916"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokLightIcon);
export default __webpack_public_path__ + "static/media/tiktokLightIcon.a0065fb38a815a6c2da7ca13aba90bff.svg";
export { ForwardRef as ReactComponent };